<template>
  <div class="flex justify-between border-gray-200">
    <h1 class="font-semibold text-3xl mb-1">Boost Rewards</h1>
  </div>

  <BoostRewardsTable />
</template>

<script setup lang="ts">
import BoostRewardsTable from './boost-rewards-table/BoostRewardsTable.vue';
</script>
